import axios from '@/common/axios'
import {
  QYGL
} from '../constants/funcUrl'

/**
 * 企业管理
 */
const qyglAction = {
  // 企业学员列表
  getEnterpriseEmployee: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.ENTERPRISEEMPLOYEE, params);
  },
  // 企业添加学员
  postEmployee: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.ROOT, params);
  },
  // 企业修改
  putEmployee: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.ROOT, params);
  },
  // 企业删除
  delEmployee: ({
    commit
  }, params) => {
    return axios.deleteAsyncWithConcat(commit, QYGL.ROOT, params);
  },
  // 企业报名
  postLearnRegistration: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.LEARNREGISTRATION, params);
  },
  // 企业保存报名
  postLearnSave: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.LEARNSAVE, params);
  },
  // 企业取消报名
  postLearnCancel: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.LEARNCANCEL, params);
  },
  // 企业获得课程报名微信支付二维码
  getLearnWeixinPayCode: ({
    commit
  }, params) => {
    return axios.getAsyncWithConcat(commit, QYGL.LEARNWEIXINPAYCODE, params);
  },
  // 企业获得课程报名微信支付结果
  getLearnWeixinPayResult: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.LEARNWEIXINPAYRESULT, params);
  },
  // 我的课程报名
  getLearnEnterpriselearn: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.LEARNENTERPRISELEARN, params);
  },
  // 企业学习管理列表
  getLearningmgtQY: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.LEARNINGMGTQY, params);
  },
  // 企业上传学员的承诺函
  postEmployeeCommitMentLetter: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.EMPLOYEECOMMITMENTLETTER, params);
  },
  // 企业补考报名课程详细信息
  getMakeUpLearnDetails: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.MAKEUPLEARNDETAILS, params);
  },
  // 企业补考报名
  postMakeUpRegistration: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.MAKEUPREGISTRATION, params);
  },
  // 我的课程报名
  getMakeUpEnterpriselearn: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.MAKEUPENTERPRISEMAKEUP, params);
  },
  // 我的企业信息
  getMyEnterprise: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.ENTERPRISEMYENTERPRISE, params);
  },
  // 企业上传缴费凭证
  putUpdateJfpz: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.LEARNUPDATEJFPZ, params);
  },
  // 企业上传缴费凭证
  postCloseLearnNotice: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.LEARNCLOSENOTICE, params);
  },
  // 企业上传缴费凭证
  putUpdateEmployeePic: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.LEARNUPDATEEMPLOYEEPIC, params);
  },
  // 证书管理-证书类型
  getCmType: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.CMTYPE, params);
  },
  // 证书管理-证书专业/岗位/工种
  getCmJob: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.CMJOB, params);
  },
  // 证书管理-证书专业/岗位/工种
  getAllCmJob: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.ALLCMJOB, params);
  },
  // 企业证书
  getCmCertificate: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.CMCERTIFICATEQY, params);
  },
  // 获取远程企业证书
  getRemoteCmCertificate: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.CMCERTIFICATEREMOTESEARCH, params);
  },
  // 查询证书详情
  getCmCertificateDetails: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.CMCERTIFICATEDETAILS, params);
  },
  // 导入证书
  importCmCertificate: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.CMCERTIFICATEIMPORT, params);
  },
  // 添加证书
  postCmCertificate: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.CMCERTIFICATE, params);
  },
  // 修改证书
  putCmCertificate: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.CMCERTIFICATE, params);
  },
  // 删除证书
  delCmCertificate: ({
    commit
  }, params) => {
    return axios.deleteAsyncWithConcat(commit, QYGL.CMCERTIFICATE, params);
  },
  // 查询人员
  getCmEmployee: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.CMEMPLOYEE, params);
  },
  // 查询人员详情
  getCmEmployeeDetails: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.CMEMPLOYEEDETAILS, params);
  },
  // 添加人员
  postCmEmployee: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.CMEMPLOYEE, params);
  },
  // 修改人员
  putCmEmployee: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.CMEMPLOYEE, params);
  },
  // 删除人员
  delCmEmployee: ({
    commit
  }, params) => {
    return axios.deleteAsyncWithConcat(commit, QYGL.CMEMPLOYEE, params);
  },
  // 查询项目
  getCmProject: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.CMPROJECT, params);
  },
  // 查询项目详情
  getCmProjectDetails: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.CMPROJECTDETAILS, params);
  },
  // 添加项目
  postCmProject: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.CMPROJECT, params);
  },
  // 修改项目
  putCmProject: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.CMPROJECT, params);
  },
  // 删除项目
  delCmProject: ({
    commit
  }, params) => {
    return axios.deleteAsyncWithConcat(commit, QYGL.CMPROJECT, params);
  },

  // 查询待开票订单
  getApproveLearns: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.INVOICEAPPROVEAPPROVELEARNS, params);
  },
  // 查询开票申请列表
  getQYInvoiceApproves: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.INVOICEAPPROVEQY, params);
  },
  // 查询开票最后一次申请记录
  getLastInvoiceApprove: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.INVOICEAPPROVELAST, params);
  },
  // 查询开票申请状态
  getInvoiceApproveStates: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.INVOICEAPPROVESTATES, params);
  },
  // 申请开票
  postApplyInvoice: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.INVOICEAPPROVEAPPLY, params);
  },
  // 企业补考报名上传缴费凭证
  putMakeUpUpdateJfpz: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.MAKEUPUPDATEJFPZ, params);
  },

  // 查询测试批次学员列表
  getBdyTestBatchEmployees: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.BDYTESTMGTBATCHEMPLOYEES, params);
  },
  // 查询测试批次学员列表
  getBdyTestBatchAddEmployees: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.BDYTESTMGTBATCHADDEMPLOYEES, params);
  },
  // 查询测试批次学员列表
  getSelectBdyTestSessions: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.BDYTESTMGTSESSIONSELECT, params);
  },
  // 删除测试批次学员
  deleteBdyTestBatchEmployee: ({
    commit
  }, params) => {
    return axios.deleteAsync(commit, QYGL.BDYTESTMGTBATCHEMPLOYEE, params);
  },
  // 添加测试批次学员
  postBdyTestBatchEmployees: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.BDYTESTMGTBATCHEMPLOYEES, params);
  },
  // 初始化企业准考证下载
  exportBdyTestBatchZkzInit: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.BDYTESTMGTBATCHZKZEXPORTINIT, params);
  },
  // 下载准考证
  exportBdyTestBatchZkz: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.BDYTESTMGTBATCHZKZEXPORT, params);
  },
  // 打包准考证并导出
  exportBdyTestBatchZkzEnd: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.BDYTESTMGTBATCHZKZEXPORTEND, params);
  },

  // 上报企业信息修改申请
  postReportEnterpriseModify: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.ENTERPRISEREPORTMODIFY, params);
  },
  // 获取企业信息修改申请状态
  getEnterpriseModifyApproveStates: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.ENTERPRISEMODIFYAPPROVESTATES, params);
  },
  // 获取企业信息修改申请列表
  getEnterpriseModifyApproves: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.ENTERPRISEMODIFYAPPROVES, params);
  },
  // 更新企业联系人信息
  putEnterpriseContact: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.ENTERPRISECONTACT, params);
  },
  // 修改密码
  putEnterprisePassword: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.ENTERPRISEPASSWORD, params);
  },
  // 修改邮箱
  putEnterpriseEmail: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.ENTERPRISEEMAIL, params);
  },
  // 修改企业资质
  putEnterpriseQualification: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.ENTERPRISEQUALIFICATION, params);
  },

  // 获得八大员练习报名添加学员列表
  getBdyPracticeEnrollAddEmployees: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.BDYPRACTICEENROLLADDEMPLOYEES, params);
  },
  // 八大员练习报名
  postBdyPracticeEnroll: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.BDYPRACTICEENROLL, params);
  },
  // 八大员练习报名更新繳費憑證信息
  putBdyPracticeEnrollJfpz: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, QYGL.BDYPRACTICEENROLLJFPZ, params);
  },

  // 查询测试批次学员列表
  getZjyTestBatchAddEmployees: ({
    commit
  }, params) => {
    return axios.getAsync(commit, QYGL.ZJYTESTMGTBATCHADDEMPLOYEES, params);
  },
  // 添加测试批次学员
  postZjyTestBatchEmployees: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, QYGL.ZJYTESTMGTBATCHEMPLOYEES, params);
  }
}

export default qyglAction;



// WEBPACK FOOTER //
// ./src/store/jzjy/actions/qyglAction.js